import axios from "axios";
// Auth rides in an httpOnly cookie set by the API — nothing token-shaped is
// stored in (or readable from) JavaScript, so XSS cannot steal the session.
const api = axios.create({
    baseURL: (process.env.API_URL || '') + '/v1',
    withCredentials: true,
});
// A 401 while we believe we're logged in means the session expired — drop the
// cached profile and return to login instead of a broken half-auth state.
api.interceptors.response.use((r) => r, (err) => {
    if (err.response?.status === 401 && localStorage.getItem("user_data")) {
        localStorage.removeItem("user_data");
        window.location.href = "/login";
    }
    return Promise.reject(err);
});
export default api;
